import { render, staticRenderFns } from "./SampleReplyList.vue?vue&type=template&id=6a0398a0"
import script from "./SampleReplyList.vue?vue&type=script&lang=js"
export * from "./SampleReplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports